<template>
    <section class="like-a-local-carousel">
        <header class="component-header container">
            <h2 class="headline-1">Explore like a Local</h2>
        </header>
        <GlobalCarousel padding="20%" :items="recommendations" class="container">
            <template #item="item">
                <CardsLikeALocal :item="item" />
            </template>
        </GlobalCarousel>
    </section>
</template>

<script setup>
    const props = defineProps({
        recommendations: {
            type: Array,
            required: true,
            default: [],
        },
    });

    const { recommendations } = toRefs(props);
</script>

<style lang="scss">
    .like-a-local-carousel {
        padding-top: 30px;
        padding-bottom: 30px;

        .carousel-component .carousel-inner {
            margin-left: 0 !important;

            .active-item .like-a-local {
                border: 1.5px solid $red;
            }
        }

        // Arrows centred on the strip rather than above it.
        //
        // `top` + `translateY` rather than the old `calc(50% - 50px)`: that
        // positioned the arrow's TOP edge, so a 42px arrow ended up centred 29px
        // above the strip. Translating by half its own height centres it
        // whatever size the arrow becomes.
        //
        // Doubled selector for specificity, not by accident. The carousel's own
        // `top: -50px` is in a SCOPED block, so it compiles with an attribute
        // selector and beats a plain three-class rule on a tie — which meant
        // this override won locally but lost in the production bundle, where the
        // arrows jumped up over the heading. Repeating the class puts it
        // decisively ahead in both.
        @media (min-width: $tablet) {
            &.like-a-local-carousel .carousel-component .arrow {
                top: 50%;
                transform: translateY(-50%);

                // Over the cards by default. Hanging them outside the container
                // needs margin to hang into; below $hd + room for both arrows
                // there isn't any, and they pushed the whole document 55px wider
                // — a horizontal scrollbar on every page carrying this block.
                left: 8px;
                // Legible where they now sit on top of a card.
                box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
            }

            &.like-a-local-carousel .carousel-component .arrow:last-of-type {
                right: 8px;
                left: unset;
            }
        }

        // Only once there is genuinely room either side of the capped content
        // do they move outside it: $hd, plus ~60px of arrow and gap per side.
        @media (min-width: $hd + 240px) {
            &.like-a-local-carousel .carousel-component .arrow {
                left: -50px;
                box-shadow: none;
            }

            &.like-a-local-carousel .carousel-component .arrow:last-of-type {
                right: -60px;
                left: unset;
            }
        }
    }
</style>
